import { siteTexts } from "../i18n/siteTexts";
import { ChallengeStatus } from "../../features/challenges/types/challengeAdmin";
import "./ChallengeStatusBadge.css";

type ChallengeStatusBadgeProps = {
  status: ChallengeStatus;
};

export default function ChallengeStatusBadge({ status }: ChallengeStatusBadgeProps) {
  const label =
    status === "pending"
      ? siteTexts.admin.statuses.pending
      : status === "started"
      ? siteTexts.admin.statuses.started
      : siteTexts.admin.statuses.finished;

  return (
    <span className={`challenge-status-badge challenge-status-badge--${status}`}>
      {label}
    </span>
  );
}

